/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getRateList = (payload, callback) =>
  req.list(
    c.GET_RATE,
    'api/v1/rpt/administrator/settings/rates',
    payload,
    callback
  );

export const getSingleRate = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_RATE,
    `api/v1/rpt/administrator/settings/rates/${id}`,
    payload,
    callback
  );

export const createRate = (payload, callback) =>
  req.create(
    c.CREATE_RATE,
    'api/v1/rpt/administrator/settings/rates',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRate = (id, payload, callback) =>
  req.update(
    c.UPDATE_RATE,
    `api/v1/rpt/administrator/settings/rates/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRate = (id, payload, callback) =>
  req.remove(
    c.REMOVE_RATE,
    `api/v1/rpt/administrator/settings/rates/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USES,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

export const clearItem = (constant, value) => req.setItem(constant, value);
